import UpdateDetailsModal from '@components/profile/student/update-details-modal'
import React, { useState } from 'react'
import { Edit3 } from 'react-feather'

const EditInfoButton = () => {
  const [isUpdateDetailsModalOpen, setIsUpdateDetailsModalOpen] = useState(
    false
  )

  return (
    <>
      <button
        className="text-orange hover:underline focus:outline-none font-600 flex items-center space-x-2"
        onClick={() => setIsUpdateDetailsModalOpen(true)}
      >
        <Edit3 size={16} />
        <span>Edit info</span>
      </button>
      <UpdateDetailsModal
        isOpen={isUpdateDetailsModalOpen}
        setIsOpen={setIsUpdateDetailsModalOpen}
      />
    </>
  )
}

export default React.memo(EditInfoButton)
